import keyMirror from 'keymirror';

export const ActionTypes = keyMirror({
  // Notifications
  NOTIFICATIONS_SEEN: null,
  NOTIFICATIONS_SEEN_TIME: null,
  NOTIFICATION_CHECKED_TIME: null,
  NOTIFICATIONS_ALL_CHECKED: null,
  NOTIFICATIONS_ALL_CHECKED_TIME: null,
  NOTIFICATION_UPDATE: null,
  NOTIFICATION_SETTINGS_LOADING: null,
  NOTIFICATION_SETTINGS_UPDATE: null,
  NOTIFICATION_FILTER_STATUS: null,
  NOTIFICATION_LOADING_STATUS: null,

  // Subscriptions
  SUBSCRIPTION_UPDATE: null,
  SUBSCRIPTION_ACTIVE_STATUS: null,
  SUBSCRIPTION_FILTER_STATUS: null,
  SUBSCRIPTION_LOADING_STATUS: null,

  // Users
  USER_UPDATE: null,
  USER_UPDATE_MANY: null,
  USER_SET_CURRENT: null,

  // Cohorts
  COHORT_UPDATE: null,

  COHORT_SCHEDULE_SET: null,
  COHORT_SCHEDULE_UPDATE: null,

  // Collection
  COLLECTION_UPDATE: null,
  COLLECTED_ITEM_UPDATE: null,
});
